import { render, staticRenderFns } from "./Actuator.vue?vue&type=template&id=08a24a64&"
import script from "./Actuator.vue?vue&type=script&lang=js&"
export * from "./Actuator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports